import { useSelector } from 'react-redux';
import { css } from 'linaria';
import Link from 'next/link';
const linkStyles = "lqd0tjb";
export const Links = ({
  toggleDevMode
}) => {
  const userId = useSelector(state => state?.user?.user_id);
  const links = [{
    src: `/profile/${userId}?src=navbar`,
    title: 'Profile',
    description: 'Articles you Recommended'
  }];
  return links.length ? <div className={linkStyles}>
      <h6>Links in progress</h6>
      {links.map(link => <Link href={link.src} key={link.title}>
          <a onClick={toggleDevMode} className="link">
            <div className="title">{link.title}</div>
            <div className="description">{link.description}</div>
          </a>
        </Link>)}
    </div> : null;
};

require("./links.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./links.js");